import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Params } from '@angular/router';
import { UserDetailDto } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import { BuildingTab } from '@pages/building-detail-page/building-tabs';
import TenantTypeEnum = UserDetailDto.TenantTypeEnum;

interface ContractorAssignmentLink {
  commands: string[];
  queryParams: Params;
  label: string;
}

@Component({
  standalone: false,
  selector: 'wr-repair-task-contractor-hint',
  templateUrl: './repair-task-contractor-hint.component.html',
  styleUrls: ['./repair-task-contractor-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepairTaskContractorHintComponent {
  private readonly currentUserService = inject(CurrentUserService);

  readonly buildingId = input.required<string>();

  readonly link = computed<ContractorAssignmentLink | undefined>(() => {
    const buildingId = this.buildingId();
    if (this.currentUserService.currentUser()?.tenantType === TenantTypeEnum.Internal) {
      return {
        commands: ['/building', buildingId],
        queryParams: { tab: BuildingTab.Responsibilities },
        label: 'am Gebäude zuweisen',
      };
    }
    if (this.currentUserService.hasPrivilege('editContractorBuildingAssignments')) {
      return {
        commands: ['/contractorBuildingAssignment'],
        queryParams: { buildingId },
        label: 'in der Gebäudezuweisung zuweisen',
      };
    }
    return undefined;
  });
}
